import React, { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { AdUsersProps } from './Ads.interface';
import { adsActions, adsSelector } from '$store/ads';
import { Loader, UserCell } from '$shared/components';
import { useTranslator } from '$hooks';
import { goBack } from '$navigation/helper';

export const AdUsers: FC<AdUsersProps> = ({ adId }) => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const { usersLoadingStatus, users } = useSelector(adsSelector);

  useEffect(() => {
    dispatch(adsActions.loadUsers(adId));
  }, [adId]);

  const handleRetry = useCallback(() => {
    dispatch(adsActions.loadUsers(adId));
  }, []);

  function renderContent() {
    if (usersLoadingStatus === 'loading' && !users.length) {
      return <Loader isWrapped />;
    }

    if (usersLoadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={
            <Button size="small" onClick={handleRetry}>
              {t('failed_button')}
            </Button>
          }
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    if (users.length === 0) {
      return <Placeholder centered>{t('ad_users_empty_description')}</Placeholder>;
    }

    return users.map((userId) => (
      <UserCell key={userId} objectId={userId} isFollowed={false} isGroup={false} />
    ));
  }

  return (
    <>
      <Header showBackButton backButtonOnClick={() => goBack()}>
        {t('ad_users_title')}
      </Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
